// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"130":"e05f4d33","401":"ed378fc0","424":"0a0c378b","487":"936d13c7","531":"f1319d99","785":"ac60639b","823":"2ad14980","998":"7ff170c2"}[chunkId] + ".chunk.js";
};